// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-SelectControl----index-module---root---3vACP","label":"src-components-SelectControl----index-module---label---2JdSm","icon":"src-components-SelectControl----index-module---icon---1lijN","element":"src-components-SelectControl----index-module---element---3xr_T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectControl/index.module.css
// module id = 618
// module chunks = 168707334958949